import { addSearchParams } from '../urlUtils';
function transformWebLargest(webLargest) {
    return webLargest
        .replace('https://audivmstest-a.akamaihd.net/brand/stage/brandportal/', 'https://pre-www.audi.de/content-audi-assets/')
        .replace('https://audivms-a.akamaihd.net/brand/', 'https://www.audi.de/content-audi-assets/');
}
function getWebLargestImages({ image: images }) {
    if (!Array.isArray(images)) {
        throw new Error(`no image array found in given object`);
    }
    return images.map(({ imageFormats }, index) => {
        if (!imageFormats) {
            throw new Error(`imageFormats not found in image on index ${index}`);
        }
        const { 'web-largest': webLargest } = imageFormats;
        if (!webLargest) {
            throw new Error(`web-largest not found in imageFormats at image on index ${index}`);
        }
        return webLargest;
    });
}
export function getImageUrls(assetValue) {
    if (!assetValue.startsWith('{'))
        return [assetValue];
    const contetAudiImage = JSON.parse(assetValue);
    return getWebLargestImages(contetAudiImage).map(transformWebLargest);
}
export function addImwidthParameter(url, maxWidth) {
    return addWidthParameter(url, maxWidth);
}
export function addWidthParameter(url, maxWidth) {
    return addSearchParams(url, new Map([['width', maxWidth.toString(10)]]));
}
//# sourceMappingURL=index.js.map